export const featureFlagsQueryKey = () => ["featureFlags"] as const;
